import script from "./ListEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ListEditor.vue?vue&type=script&setup=true&lang=js"

import "./ListEditor.vue?vue&type=style&index=0&id=05b05857&lang=less"

const __exports__ = script;

export default __exports__